// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');
$export($export.S, 'Number', {
  MIN_SAFE_INTEGER: -0x1fffffffffffff
});